
  export class DocumentTypeAll {
    "bpIdentificationCategory1":String;
    "bpIdentificationCategory2":String;
    "bpIdentificationCategory3":String;
    "card1":String;
    "card2":String;
    "card3":String;
    "other1":String;
    "other2":String;
    "other3":String;
    "bpIdentificationCategorySapCode":String;

  }


// WEBPACK FOOTER //
// D:/Aliva/IPCL/IPCL_SELF_CARE/src/app/models/documentType/documentType.ts